export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-selection/src/selection/empty.js
// module id = HMDn
// module chunks = 0